import { Button, Form, Input } from "antd";
import styled from "styled-components";

// 登录容器
export const Container = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-color:#0095E2;
  // background-image: url(${require("@/assets/img/login/bg2.png")});
  /* background-image: url(${require("@/assets/img/login/bg.png")}); */
  background-size: cover;
  background-repeat: no-repeat;
  align-items: center;
`;

// 登录标题
export const Title = styled.div`
  font-size: 24px;
  /* font-family: Alibaba PuHuiTi-Medium, Alibaba PuHuiTi; */
  font-weight: 500;
  line-height: 39px;
  color: #444444;
  margin-left: 10px;
`;

// 登录标题
export const WelCome = styled.div`
  font-size: 20px;
  font-weight: 700;
  color: #444444;
`;

// 登录标题
export const TitleBox = styled.div`
  display: flex;
  padding: 20px;
  margin-bottom: 20px;
`;

// 登录标题
export const LeftBox = styled.div`
  width: 50%;
  text-align: center;
  position: relative;
  &::after {
    content: "";
    display: block;
    height: 338px;
    width: 0px;
    border: 1px solid #eeeeee;
    position: absolute;
    right: 0;
    top: 80px;
  }
`;

// 登录标题
export const LoginBox = styled.div`
  width: 1000px;
  height: 498px;
  background: #ffffff;
  border-radius: 20px 20px 20px 20px;
  display: flex;
`;

// 登录主体
export const LoginContainer = styled(Form)`
  width: 50%;
  z-index: 1;
  padding: 80px;
  background: white;
  border-radius: 30px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

// 表单项
export const LoginItem = styled(Form.Item)`
  margin: 20px 0;
  text-align: center;
`;

// 账号输入框
export const AccountInput = styled(Input)`
  border: 1px solid black;
  border-radius: 20px;
`;

// 密码输入框
export const PasswordInput = styled(Input.Password)`
  border: 1px solid black;
  border-radius: 20px;
`;

// 登录按钮
export const SubmitButton = styled(Button)`
  width: 100%;
  height: 48px;
  // background: linear-gradient(45deg, #886dff 0%, #af5fff 100%);
  background: #145eff; 
  border-radius: 20px 20px 20px 20px;
  opacity: 1;
  margin-top: 20px;
`;
